import React, { forwardRef } from "../../../__compat__/react/main.entry.mjs.mjs";
import { TextFieldExtensionButton } from "../../TextField/TextFieldExtension.mjs.mjs";
import { Icon } from "../../Icon/index.mjs.mjs";
export const DateInputExtension = forwardRef(function DatePickerExtension(props, ref) {
    return (React.createElement(TextFieldExtensionButton, { ref: ref, ...props },
        React.createElement(Icon, { name: "calendar-events", size: "small" })));
});
//# sourceMappingURL=DateInputExtension.mjs.mjs.map